import { objectOf, maybe, arrayOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const isSourceField = objectOf({
  index: number,
  name: string,
  data_type: maybe(string),
});

const isMappingRule = objectOf({
  source_path: maybe(string),
  source_index: maybe(number),
  source_data_type: maybe(string),
  destination_field: maybe(string),
  destination_data_type: maybe(string),
  mapping_status: maybe(string),
});

const isDataMap = objectOf({
  name: maybe(string),
  mapper_type: maybe(string),
  import_class: maybe(string),
  mapping_rules: maybe(arrayOf(isMappingRule)),
});

const isDestinationField = objectOf({
  name: string,
  data_type: maybe(string),
});

const isDestinations = objectOf({
  identifiers: arrayOf(isDestinationField),
  default_fields: arrayOf(isDestinationField),
  custom_fields: arrayOf(isDestinationField),
  mapper_import_kind: string,
});

const isMappingSummary = objectOf({
  identifier_mapped: maybe(boolean),
});

export const isPostInitializeCdiMapResult = objectOf({
  data_map: isDataMap,
  source: arrayOf(isSourceField),
  destinations: isDestinations,
  mapping_summary: isMappingSummary,
});
